/**
 * Общие методы для применения на компонентах - диалоговых окон.
 */
export const methodsForDialogMixin = {
  /**
   * Фокус при показе диалогового окна, если нужно.
   */
  mounted() {
    if (this.$refs.elementForFocus) {
      this.$refs.elementForFocus.focus();
    }
  },
  methods: {
    /**
     * Закрытие диалогового окна.
     *
     * @param data
     */
    closeDialog(data) {
      this.$vuedals.close(data);
    },
  },
};
